export default "__VITE_ASSET__5abe5130__"